import {
  AvailableCognitoIdentity,
  AvailableLoginWay,
  AvailableSocialProvider,
} from "./auth/schemas"

/** @type {import("./auth/types").SocialLoginProviderMap} */
export const SocialLoginProviderMap = {
  // Default
  [AvailableSocialProvider.enum.Apple]: {
    provider: AvailableCognitoIdentity.enum.SignInWithApple,
  },
  [AvailableSocialProvider.enum.Facebook]: {
    provider: AvailableCognitoIdentity.enum.Facebook,
  },
  [AvailableSocialProvider.enum.Google]: {
    provider: AvailableCognitoIdentity.enum.Google,
  },

  // OIDC
  [AvailableSocialProvider.enum.Twitter]: {
    customProvider: AvailableCognitoIdentity.enum.Twitter,
  },
  [AvailableSocialProvider.enum.LINE]: {
    customProvider: AvailableCognitoIdentity.enum.LINE,
  },
}

/** @type {import("./auth/types").ProviderIdentityMap} */
export const ProviderIdentityMap = {
  [AvailableSocialProvider.enum.Apple]:
    AvailableCognitoIdentity.enum.SignInWithApple,
  [AvailableSocialProvider.enum.Facebook]:
    AvailableCognitoIdentity.enum.Facebook,
  [AvailableSocialProvider.enum.Google]: AvailableCognitoIdentity.enum.Google,
  [AvailableSocialProvider.enum.Twitter]: AvailableCognitoIdentity.enum.Twitter,
  [AvailableSocialProvider.enum.LINE]: AvailableCognitoIdentity.enum.LINE,
}

export const ProviderLoginWayMap = {
  [AvailableSocialProvider.enum.Apple]: AvailableLoginWay.enum.SignInWithApple,
  [AvailableSocialProvider.enum.Facebook]: AvailableLoginWay.enum.Facebook,
  [AvailableSocialProvider.enum.Google]: AvailableLoginWay.enum.Google,
  [AvailableSocialProvider.enum.Twitter]: AvailableLoginWay.enum.Twitter,
  [AvailableSocialProvider.enum.LINE]: AvailableLoginWay.enum.LINE,
}

export const IdentityLoginWayMap = {
  [AvailableCognitoIdentity.enum.SignInWithApple]:
    AvailableLoginWay.enum.SignInWithApple,
  [AvailableCognitoIdentity.enum.Facebook]: AvailableLoginWay.enum.Facebook,
  [AvailableCognitoIdentity.enum.Google]: AvailableLoginWay.enum.Google,
  [AvailableCognitoIdentity.enum.Twitter]: AvailableLoginWay.enum.Twitter,
  [AvailableCognitoIdentity.enum.LINE]: AvailableLoginWay.enum.LINE,
}

export const AppCenterApiName = {
  AppCenterApi: "AppCenterApi",
  AppCenterApiWithToken: "AppCenterApiWithToken",
  AppCenterApiWithoutVersionWithIdToken:
    "AppCenterApiWithoutVersionWithIdToken",
}

export const AuthCallbackStatus = Object.freeze({
  LinkAccountSuccess: "LinkAccountSuccess",
  LinkAccountFailed: "LinkAccountFailed",
  SocialLoginFailed: "SocialLoginFailed",
  SocialAccountUsedByOtherUser: "SocialAccountUsedByOtherUser",
})
/** @typedef {keyof typeof AuthCallbackStatus} TAuthCallbackStatus */

export const LATEST_POLICY_VERSION =
  process.env.GATSBY_LATEST_POLICY_VERSION || "default_policy"

export const TERMS_OF_SERVICE_URL =
  "https://www.giant-bicycles.com/us/termsconditions"

export const PRIVACY_POLICY_URL =
  "https://www.giant-bicycles.com/global/giant-id-privacy-notice"
